import { ClientPublicModel } from './../models/client.model';
import { Observable } from 'rxjs';
import { StorePublicModel } from '../models/store-public.model';


export abstract class ClientPublicRepository {
    abstract getAll(): Observable<ClientPublicModel[]>;
}
